import { useApiQuery } from 'theSource/utils';
import { useConfigurationQuery } from 'theSource/queries';
import {
  AcaDocumentsResponseDto,
  AcaDocumentDto,
  hasFormProperty,
} from './types';
import { ACA_DOCUMENTS_QUERY_KEY } from './utils';

export interface UseAcaDocumentsQueryProps {
  enabled: boolean;
}

export const useAcaDocumentsQuery = ({
  enabled,
}: UseAcaDocumentsQueryProps) => {
  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;

  const {
    data: responseData,
    isLoading,
    isFetching,
  } = useApiQuery<AcaDocumentsResponseDto>({
    queryKey: ACA_DOCUMENTS_QUERY_KEY,
    endpoint: `/document_library/1095c`,
    config: {
      baseURL: `${lumosApiHost}/v1/self_service`,
    },
    showErrorSnackbar: false,
    enabled: enabled,
  });

  // Transform the response data to always return an array of documents
  const documents: AcaDocumentDto[] | undefined = responseData?.data
    ? hasFormProperty(responseData.data)
      ? responseData.data.forms
      : responseData.data
    : undefined;

  const acaPaperReductionActDisclaimer: String | undefined = responseData?.data
    ? hasFormProperty(responseData.data)
      ? responseData.data.aca_paper_reduction_act_disclaimer
      : undefined
    : undefined;

  return {
    data: {
      data: documents,
      acaPaperReductionActDisclaimer: acaPaperReductionActDisclaimer,
    },
    isLoading,
    isFetching,
  };
};
